import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1280px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-2xl font-bold tracking-tight ${scrolled || !isHome ? "text-primary-500" : "text-white"}`}>
              91吃瓜
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? scrolled || !isHome ? "bg-primary-100 text-primary-700" : "bg-white/20 text-white"
                  : scrolled || !isHome ? "text-foreground-700 hover:bg-background-100" : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700"
                    : scrolled || !isHome ? "text-foreground-700 hover:bg-background-100" : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : scrolled || !isHome ? "text-foreground-700 hover:bg-background-100" : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? "text-foreground-700 hover:bg-background-100" : "text-white/80 hover:bg-white/10"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className={`px-4 py-2.5 rounded-lg text-sm font-medium ${location.pathname === "/" ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"}`}>
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium ${location.pathname === `/category/${cat.slug}` ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className={`px-4 py-2.5 rounded-lg text-sm font-medium ${location.pathname === "/about" ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"}`}>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}